import { IncidentsPage as IncidentsPageMobile } from "./IncidentsPage.mobile";

function IncidentsPageMain() {
  return <IncidentsPageMobile /> ;
}

export default IncidentsPageMain;
